import React, { useMemo } from "react";
import type { FormProps } from "antd";
import { Button, Form, InputNumber, Select, Space, notification } from "antd";
import axios from "axios";

import { API_BASE_URL } from "shared/api/config";

type FieldType = {
  type: "frame" | "paper";
  size: string;
  quantity: number;
};

const sizeOptions = {
  paper: ["A6", "A5", "A4", "A3"],
  frame: ["A5", "A4", "A3"],
};

interface Props {
  onSuccess?: () => void;
}

const Income: React.FC<Props> = ({ onSuccess }) => {
  const [form] = Form.useForm<FieldType>();
  const selectedType = Form.useWatch("type", form);
  const options = useMemo(
    () => (selectedType ? sizeOptions[selectedType] : []).map((size) => ({ label: size, value: size })),
    [selectedType]
  );

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    try {
      await axios.post(`${API_BASE_URL}/warehouse/create`, values);
      notification.success({ message: "Орлого бүртгэгдлээ" });
      form.resetFields();
      onSuccess?.();
    } catch (error: any) {
      notification.error({
        message: "Алдаа",
        description: error.response?.data?.message || "Орлого авахад алдаа гарлаа",
      });
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      initialValues={{ type: "paper" }}
    >
      <Form.Item name="type" label="Төрөл" rules={[{ required: true, message: "Төрөл сонгоно уу" }]}>
        <Select
          options={[
            { label: "Цаас", value: "paper" },
            { label: "Жааз", value: "frame" },
          ]}
          onChange={() => form.setFieldValue("size", undefined)}
        />
      </Form.Item>

      <Form.Item name="size" label="Хэмжээ" rules={[{ required: true, message: "Хэмжээ сонгоно уу" }]}>
        <Select options={options} placeholder="Хэмжээ сонгоно уу" />
      </Form.Item>

      <Form.Item
        name="quantity"
        label="Тоо ширхэг"
        rules={[{ required: true, message: "Тоо оруулна уу" }]}
      >
        <InputNumber min={1} precision={0} style={{ width: "100%" }} />
      </Form.Item>

      <Space style={{ width: "100%", justifyContent: "flex-end" }}>
        <Button type="primary" htmlType="submit">
          Орлого авах
        </Button>
      </Space>
    </Form>
  );
};

export default Income;
